<div *ngIf="audio" class="flex w-full items-center gap-4 border border-pl-gray-250 p-2 sm:gap-10">
  <pl-icon
    [name]="audio.paused ? PlIcon.play_circle : PlIcon.pause_circle"
    class="h-20 w-20 cursor-pointer text-pl-gray-250 hover:text-pl-orange-800"
    [ngClass]="{
      'text-pl-gray-250': !userClickedOnceOnPlayButton(),
      'text-pl-orange-500': userClickedOnceOnPlayButton()
    }"
    (click)="onPlayPauseClicked()"
  />
  <div class="flex min-w-0 flex-1 flex-col gap-2">
    <h4 class="truncate text-pl-black">{{ title }}</h4>
    <div class="flex items-center gap-2">
      <p class="hidden w-14 text-lg sm:block">{{ audioTimeProgress | plSecondsToTime }}</p>
      <pl-slider
        class="flex-1"
        (ngModelChange)="onSliderChange($event)"
        [(ngModel)]="audioTimeProgress"
        [handleColor]="SliderColor.gray"
        [inactiveTrackColor]="SliderColor.orange"
        [max]="audio.duration"
        [min]="0"
        [progressBarHeight]="ProgressBarHeight.large"
        [showTicks]="false"
        [step]="0.01"
      />
      <p class="hidden w-14 text-lg sm:block">{{ audio.duration | plSecondsToTime }}</p>
    </div>
  </div>
</div>
